import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { AlertService } from "@app/_services";
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MaintenanceEventShortTermRentalService } from "../maintenance-event-shorttermrental.service";
import { MaintenanceEventShortTermRental } from "../maintenance-event-shorttermrental";

@Component({
    selector: "app-maintenance-event-shorttermrental",
    templateUrl: "./maintenance-event-shorttermrental.component.html",
    styleUrls: ["./maintenance-event-shorttermrental.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MaintenanceEventShortTermRentalComponent implements OnInit {
  constructor(
    private primengConfig: PrimeNGConfig,
    private maintenanceEventShortTermRentalService: MaintenanceEventShortTermRentalService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title;
    this.maintenanceEventShortTermRental = data.maintenanceEventShortTermRental;
    this.maintenanceEventId =
      data.maintenanceEventShortTermRental?.maintenanceEventId;
    this.shortTermRentalId =
      data.maintenanceEventShortTermRental?.shortTermRentalId;
  }

  @Input() maintenanceEventShortTermRental: MaintenanceEventShortTermRental;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  maintenanceEventId: number;
  shortTermRentalId: number;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    shortTermRentalId: [],
    propertyCode: [],
    opsNote: [],
    createDate: [],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole maintenanceEventShortTermRental object
    if (this.maintenanceEventShortTermRental) {
      this.maintenanceEventId =
        this.maintenanceEventShortTermRental.maintenanceEventId;
      this.shortTermRentalId =
        this.maintenanceEventShortTermRental.shortTermRentalId;
      this.fixDates();
      this.form1.patchValue(this.maintenanceEventShortTermRental);
    }
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.shortTermRentalId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.maintenanceEventShortTermRentalService
        .add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log("property-add SUCCESS: " + JSON.stringify(res));
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.maintenanceEventShortTermRental =
              res.data.maintenanceEventShortTermRental;
            this.doAdd.emit(this.maintenanceEventShortTermRental);
          },
          (err: any) => {
            console.log(
              "maintenanceEventShortTermRental-add FAIL: " + JSON.stringify(err)
            );
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log(
      "maintenanceEventShortTermRental: " + JSON.stringify(this.form1.value)
    );
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.maintenanceEventShortTermRentalService
        .update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log("property-update SUCCESS: " + JSON.stringify(res));
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.maintenanceEventShortTermRental =
              res.data.maintenanceEventShortTermRental;
            this.doUpdate.emit(this.maintenanceEventShortTermRental);
          },
          (err: any) => {
            console.log("property-update FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.maintenanceEventShortTermRentalService
        .delete(
          this.maintenanceEventShortTermRental.maintenanceEventId,
          this.maintenanceEventShortTermRental.shortTermRentalId
        )
        .subscribe(
          (res: any) => {
            console.log(
              "maintenanceEventShortTermRental-delete SUCCESS: " +
                JSON.stringify(res)
            );
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.maintenanceEventShortTermRental);
          },
          (err: any) => {
            console.log(
              "maintenanceEventShortTermRental-add FAIL: " + JSON.stringify(err)
            );
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      maintenanceEventId: [this.maintenanceEventId],
      shortTermRentalId: [this.shortTermRentalId],
      propertyCode: [],
      opsNote: [],
      createDate: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.maintenanceEventShortTermRental.createDate = moment(
      this.maintenanceEventShortTermRental.createDate
    ).toDate();
  }
}
